import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { topCollectorsRequest } from 'store/collection/collectionActions';
import { selectCollectionById } from 'store/collection/collectionSelectors';
import { type RootState } from 'store/store';
import TopCollectors from 'views/Sale/components/TopCollectors/TopCollectors';

import { ButtonWrapper } from '../styled';

const TopCollectorsList = ({ collectionId }: { collectionId: string }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { viewedTopCollectors } = useSelector((state: RootState) => state.collections.itemsCachedState[collectionId] || {});

  const collection = useSelector(selectCollectionById(collectionId));

  /*
   * Get cards data
   */
  const [isShowMore, setIsShowMore] = useState(true);
  const topCollectors = collection?._cached_top_collectors || [];

  useEffect(() => {
    setIsShowMore(!viewedTopCollectors);
  }, [collectionId]);

  const handleTopCollectors = () => {
    if (collection?.id) {
      dispatch(topCollectorsRequest({ id: collection.id }));
      setIsShowMore(false);
    }
  };

  if (!topCollectors || topCollectors.length <= 1) {
    return null;
  }
  return (
    <div data-test-id="top_collectors_wrapper_full">
      <TopCollectors list={topCollectors} />
      {isShowMore && topCollectors.length > 9 && (
        <ButtonWrapper>
          <Button
            data-test-id="view_all_button"
            size="regular"
            fluid
            background="transparent"
            border="primary"
            textColor="primary"
            onClick={handleTopCollectors}
          >
            {t('collection.viewTopCollectors')}
          </Button>
        </ButtonWrapper>
      )}
    </div>
  );
};

export default TopCollectorsList;
